import { Popover2, Classes } from '@blueprintjs/popover2';
import { Portal } from '@blueprintjs/core';
import React, { useState, useCallback, useEffect } from 'react';
import classNames from 'classnames';

function getPopoverKey(targetOffset) {
  return targetOffset === undefined ? 'default' : `${targetOffset.left}x${targetOffset.top}`;
}

const HierarchyPopover = ({ content, node, setMouseEvent, targetOffset }) => {
  const [isOpen, setIsOpen] = useState(false);

  const cancelContextMenu = useCallback((e) => e.preventDefault(), []);

  const handlePopoverInteraction = useCallback((nextOpenState) => {
    if (!nextOpenState) {
      setIsOpen(false);
      setMouseEvent(undefined);
    }
  }, []);

  // Popover2 should attach its ref to the virtual target we render inside a Portal, not the "inline" child target
  const renderTarget = useCallback(
    ({ ref }) => (
      <Portal>
        <div className={Classes.CONTEXT_MENU2_VIRTUAL_TARGET} style={targetOffset} ref={ref} />
      </Portal>
    ),
    [targetOffset]
  );

  const Popover = () => (
    <Popover2
      content={
        // this prevents right-clicking inside our context menu
        <div onContextMenu={cancelContextMenu} style={{ padding: '5px' }}>
          {content}
        </div>
      }
      enforceFocus={false}
      // Generate key based on offset so that a new Popover instance is created
      // when offset changes, to force recomputing position.
      key={getPopoverKey(targetOffset)}
      hasBackdrop={true}
      backdropProps={{ className: Classes.CONTEXT_MENU2_BACKDROP }}
      isOpen={isOpen}
      onInteraction={handlePopoverInteraction}
      popoverClassName={classNames(Classes.CONTEXT_MENU2_POPOVER2)}
      placement="right-start"
      positioningStrategy="fixed"
      rootBoundary="viewport"
      renderTarget={renderTarget}
      transitionDuration={100}
    />
  );

  useEffect(() => {
    setIsOpen(true);
  }, [targetOffset, node]);

  return <Popover onContextMenu={cancelContextMenu} />;
};

export default HierarchyPopover;
